import { types, getParent, flow, cast } from 'mobx-state-tree';
import { LocField } from 'store/localizations/umbraco';
import { CmsApi } from 'service/axios-api';
import { IFeedStore } from '.';

const MediaOne = types.model('MediaOne', {
    Type: types.string,
    Image: LocField,
});

const MediaStore = types
    .model('MediaStore', {
        list: types.array(MediaOne),
        showDialog: types.optional(types.boolean, false),
    })
    .views((self) => ({
        get productId(): string {
            return getParent<IFeedStore>(self).productId;
        },
    }))
    .actions((self) => ({
        fetch: flow(function* () {
            const data = yield CmsApi.get(`/screenshots/regions/{regionCode}/${self.productId}/list.json`).catch(() => []);
            self.list = cast(data);
        }),
        setShowDialog(val: boolean) {
            self.showDialog = val;
        },
    }));

export default MediaStore;
